import resolveConfig from 'tailwindcss/resolveConfig';
import config from 'tailwind.config.js';
export default resolveConfig(config);